import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, Btn } from "@/components/UI";
import { Send, RefreshCw } from "lucide-react";
import { apiError } from "@/lib/customers";
import { fmtQty } from "@/lib/products";

const TONE = { NOT_CONFIGURED: "text-slate-600", SEND_FAILED: "text-rose-700", UNMATCHED: "text-amber-700" };
const dt = (s) => (s ? new Date(s).toLocaleString("tr-TR") : "—");

function Shipments({ rows }) {
  if (!rows.length) return null;
  return (
    <div className="mt-2 text-xs" data-testid="metaerp-shipments">
      <div className="font-semibold text-slate-700 mb-1">MetaERP Sevkiyatları (bilgi — stok/cari etkisi yok)</div>
      {rows.map((s, i) => (
        <div key={i} className="border-t border-slate-100 py-1">
          {dt(s.shipped_at)} · {s.lines.map((l) => `${l.product_code}: ${fmtQty(l.shipped_qty)} sevk${l.remaining_qty != null ? `, ${fmtQty(l.remaining_qty)} kalan` : ""}`).join(" · ")}
        </div>
      ))}
    </div>
  );
}

export function MetaErpPanel({ so, canSend }) {
  const [m, setM] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get(`/sales-orders/${so.id}/metaerp`).then(setM).catch(() => setM(null));
  useEffect(() => { load(); }, [so.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!m) return null;
  const sendable = ["approved", "partial", "completed"].includes(so.status) && !m.metaerp_order_id;
  const send = async () => {
    setBusy(true);
    try { await api.post(`/sales-orders/${so.id}/metaerp/send`); } catch (e) { window.alert(apiError(e, "MetaERP gönderimi başarısız")); }
    setBusy(false); load();
  };
  return (
    <Card className="p-4 mt-4" data-testid="metaerp-panel">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-sm font-semibold">MetaERP Entegrasyonu</div>
          <div className={`text-xs mt-0.5 ${TONE[m.metaerp_status] || "text-emerald-700"}`} data-testid="metaerp-status">
            {m.metaerp_status_label || (m.configured ? "Henüz gönderilmedi" : "MetaERP bağlantısı yapılandırılmadı")}
            {m.metaerp_order_id && <> · MetaERP #{m.metaerp_order_id}</>} · Son senkron: {dt(m.metaerp_last_sync_at)}
          </div>
          {m.metaerp_error && <div className="text-[11px] text-rose-600 mt-0.5" data-testid="metaerp-error">{m.metaerp_error}</div>}
          {m.metaerp_unmatched.map((u, i) => <div key={i} className="text-[11px] text-amber-700" data-testid={`metaerp-unmatched-${i}`}>Eşleşmeyen: {u.product_code || u.product_name || ""} {u.reason || ""}</div>)}
        </div>
        <div className="flex gap-1">
          <Btn size="sm" variant="secondary" onClick={load} data-testid="metaerp-refresh"><RefreshCw size={12} /></Btn>
          {canSend && sendable && <Btn size="sm" onClick={send} disabled={busy} data-testid="metaerp-send"><Send size={12} /> {m.metaerp_status === "SEND_FAILED" ? "Tekrar Dene" : "MetaERP'ye Gönder"}</Btn>}
        </div>
      </div>
      <Shipments rows={m.metaerp_shipments} />
    </Card>
  );
}
